import React from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';

import PrincipalMaster from './master/Principal';
import PublicMaster from './master/Public';
import { Utils } from '../services';

const styles = {
    styleButtons: {
        height: 100,
    },
    styleLabelButtons: {
        fontSize: 20,
        color: '#2957a4',
    },
};

const Home = (props) => {
    const MasterPage = Utils.getUsuarioEstaLogado()
        ? PrincipalMaster
        : PublicMaster;

    return (
        <MasterPage title="O que desejas?" {...props}>
            {!Utils.getUsuarioEstaLogado() && (
                <div style={{ marginTop: 24 }}>
                    <RaisedButton
                        onClick={() => props.history.push('/login')}
                        fullWidth
                        style={styles.styleButtons}
                        type="submit"
                        labelStyle={styles.styleLabelButtons}
                        label="Fazer login"
                        default
                    />
                </div>
            )}

            {Utils.getUsuarioEstaLogado() && (
                <div style={{ marginTop: 24 }}>
                    <RaisedButton
                        onClick={() =>
                            props.history.push('/projetos-avaliador')
                        }
                        fullWidth
                        style={styles.styleButtons}
                        type="submit"
                        labelStyle={styles.styleLabelButtons}
                        label="Avaliar Meus Resumos/Projetos"
                        default
                    />
                </div>
            )}

            <div style={{ marginTop: 24 }}>
                <RaisedButton
                    fullWidth
                    onClick={() => props.history.push('/inscricao')}
                    style={styles.styleButtons}
                    type="submit"
                    labelStyle={styles.styleLabelButtons}
                    label="Submeter Resumo/Projeto"
                    default
                />
            </div>

            {/*
            <div style={{ marginTop: 24 }}>
                <RaisedButton fullWidth href="" style={styles.styleButtons} type="submit" labelStyle={styles.styleLabelButtons} label="Anais/Certificados de Projetos" default />
            </div>

            <div style={{ marginTop: 24 }}>
                <RaisedButton fullWidth href="" style={styles.styleButtons} type="submit" labelStyle={styles.styleLabelButtons} label="Inscreve-se de Ouvinte" default />
            </div>

            <div style={{ marginTop: 24 }}>
                <RaisedButton fullWidth href="" style={styles.styleButtons} type="submit" labelStyle={styles.styleLabelButtons} label="Certificados de Ouvinte" default />
            </div>
            */}
        </MasterPage>
    );
};

Home.propTypes = {
    history: PropTypes.shape({ push: PropTypes.func.isRequired }).isRequired,
};

export default Home;
